import { DefaultPagination } from "../../constants/GeneralConstants";
import {
  deleteRequest,
  sendCreateOrUpdateRequest,
  sendGetRequest,
} from "../../utils/api/apiUtils";

// Urls
import {
  getZonesUrl,
  createZoneUrl,
  updateZoneUrl,
  deleteZoneUrl,
  getSubZonesUrl,
  createSubZonesUrl,
  updateSubZonesUrl,
  deleteSubZonesUrl,
} from "../urls/ZonesAndSubZonesURL";

export async function getZonesFn(regionId, pageNo, pageSize) {
  const headerParams = {
    "Content-Type": "application/json",
  };

  const params = {
    _type: "ZONE",
    pn: pageNo || DefaultPagination.pageNumber,
    ps: pageSize || DefaultPagination.pageSize,
  };

  const url = getZonesUrl.replace(":regionId", regionId);

  return sendGetRequest(url, params, true, headerParams);
}

export async function createZoneFn(zoneBean) {
  const headerParams = {
    "Content-Type": "application/json",
  };

  return sendCreateOrUpdateRequest(
    createZoneUrl,
    zoneBean,
    true,
    "POST",
    headerParams
  );
}

export async function updateZoneFn(regionId, zoneBean) {
  const headerParams = {
    "Content-Type": "application/json",
  };

  return sendCreateOrUpdateRequest(
    updateZoneUrl.replace(":regionId", regionId),
    zoneBean,
    true,
    "PUT",
    headerParams
  );
}

export async function deleteZoneFn(regionId, cityId) {
  const params = {
    _cityId: cityId,
  };

  const url = deleteZoneUrl.replace(":regionId", regionId);

  return deleteRequest(url, {}, true, params);
}

export async function getSubZonesFn(
  cityId,
  zoneId,
  searchText,
  pageNo,
  pageSize
) {
  const headerParams = {
    "Content-Type": "application/json",
  };

  const params = {
    _city: cityId,
    _zoneId: zoneId,
    pn: pageNo || DefaultPagination.pageNumber,
    ps: pageSize || DefaultPagination.pageSize,
  };

  if (searchText) {
    params._zoneName = searchText;
  }

  return sendGetRequest(getSubZonesUrl, params, true, headerParams);
}

export async function createSubZonesFn(cityId, subZonesBean) {
  const headerParams = {
    "Content-Type": "application/json",
  };

  const params = { cityId };

  return sendCreateOrUpdateRequest(
    createSubZonesUrl,
    subZonesBean,
    true,
    "POST",
    headerParams,
    params
  );
}

export async function updateSubZonesFn(cityId, subzoneListId, subZonesBean) {
  const headerParams = {
    "Content-Type": "application/json",
  };

  const params = { cityId };

  return sendCreateOrUpdateRequest(
    updateSubZonesUrl.replace(":subzoneListId", subzoneListId),
    subZonesBean,
    true,
    "PUT",
    headerParams,
    params
  );
}

export async function deleteSubZonesFn(subzoneListId) {
  const url = deleteSubZonesUrl.replace(":subzoneListId", subzoneListId);
  return deleteRequest(url);
}
